<template>
  <pt-fast-loan-audit-table class="pt-fast-loan-audit-table__withData" :tableLabels="tableLabels" @getTableData="getTableData"
  :tableData="tableData" :totalNumber="totalNumber" ref="table">
      <slot/>
  </pt-fast-loan-audit-table>
</template>

<script>
import PtFastLoanAuditTable from './index'
export default {
  name: 'pt-fast-loan-audit-table__withData',
  components: {
    'pt-fast-loan-audit-table': PtFastLoanAuditTable
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isFromRouter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      totalNumber: 0,
      tableData: []
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (!this.isFromRouter) {
          this.resetPage()
        } else {
          this.isOutside = true
          this.getTableData(this.page)
        }
      },
      deep: true
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next, size) {
      let paramsData = JSON.parse(JSON.stringify(this.paramsData))
      if (paramsData.status === 'ALL') {
        this.$delete(paramsData, 'status')
      }
      let data = {
        pageableParam: {
          page: this.page,
          size: size || 10
        },
        ...paramsData
      }
      console.log('data++', data)
      this.$store.dispatch('flashBorrowList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      })
    }
  }
}
</script>
